import { createAction } from '@reduxjs/toolkit';

export const setReleaseIssueModalOpen = createAction<unknown, string>('SET_RELEASE_ISSUE_MODAL_OPEN');
export const setReleaseIssueModalError = createAction('SET_RELEASE_ISSUE_MODAL_ERROR');
